import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollTitleAnimation {
  constructor(el) {
    this.dom = {el: el};
    this.direction = this.dom.el.dataset.direction;

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    gsap.set(this.dom.el, {
      y: '100%'
    });
    gsap.to(this.dom.el, {
      // y: `${this.direction}50%`,
      y: `0`,
      // rotation: 360,
      duration: 4,
      scrollTrigger: {
        trigger: this.dom.el,
        start: 'top bottom',
        end: 'center center',
        // toggleActions: 'play none none reverse',
        toggleActions: 'play pause resume reset',
        markers: false,
        id: 'endless',
        // scrub: true,
        scrub: 1.2 // smoothing
      }
    })
  }
}

export default ScrollTitleAnimation